import * as z from "zod";

export const putOdooIntegration = {
  name: "putOdooIntegration" as const,
  input: z.object({
    apiKey: z.string().optional(),
    url: z.string(),
    database: z.string(),
    username: z.string(),
    version: z.union([z.literal(16), z.literal(17)]),
    autoPostCreditNotes: z.boolean(),
    creditNoteJournalId: z.number().int().positive().nullable().optional(),
    partialReturnCorrectionConceptId: z
      .number()
      .int()
      .positive()
      .nullable()
      .optional(),
    fullReturnCorrectionConceptId: z
      .number()
      .int()
      .positive()
      .nullable()
      .optional(),
  }),
  output: z.object({}),
};
